
webpack.register(
    'modules/right-rail/streaming-schedule/streaming-schedule',
    function() {
        return import('modules/right-rail/streaming-schedule/streaming-schedule');
    },
    true
);